import { CoreIcon } from '../core-icon';
import arrowRightSVG from '../../assets/icons/arrow-right.svg';
import type { IconProps } from '../core-icon';

export const ArrowRightIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={arrowRightSVG} {...props} />;
};
